<template>
  <v-container class="d-flex justify-center">
    <v-card
      v-if="calibration"
      class="pa-4 py-8 d-flex flex-column align-center"
      flat
      max-width="1000"
    >
      <section class="d-flex justify-center align-center">
        <img
          :src="
            institution && institution.logoPath
              ? institution.logoPath
              : 'https://i.imgur.com/yItTg2c.png'
          "
          style="object-fit: contain; max-height: 60px"
        />
        <h1 class="ml-5">
          <strong style="font-size: 2em !important">
            {{ $t('CERTIFICADO DE') }}
          </strong>
          <strong
            class="secondary--text"
            style="vertical-align: bottom; font-size: 2em !important"
          >
            {{ $t('CALIBRAÇÃO') }}
          </strong>
        </h1>
      </section>

      <section>
        <v-row class="ma-0" dense>
          <v-col cols="6">
            <strong>Certificado de Calibração Nº: </strong>
            <strong class="secondary--text"> {{ calibration.number }} </strong>
          </v-col>
          <v-col cols="6">
            <strong> Data Calibração: </strong>
            <span class="secondary--text">
              {{ formatDateTime(calibration.date) }}
            </span>
            <br />
            <strong> Próxima Calibração: </strong>
            <span class="secondary--text">
              {{ formatMonth(calibration.nextCalibrationDate) }}
            </span>
          </v-col>
        </v-row>
      </section>

      <section>
        <div class="section-title">Dados Gerais</div>

        <v-row class="ma-0" dense>
          <v-col cols="6">
            <strong>Unidade: </strong>
            <span>{{
              calibration.unidade ? calibration.unidade.name : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Equipamento: </strong>
            <span>{{
              calibration.equipment
                ? calibration.equipment.name
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Endereço: </strong>

            <span>
              {{
                calibration.unidade
                  ? `${calibration.unidade.address},${calibration.unidade.locationNumber}, ${calibration.unidade.district}`
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Fabricante: </strong>
            <span>{{
              calibration.equipment
                ? calibration.equipment.manufacturer
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Cidade/UF: </strong>
            <span>
              {{
                calibration.unidade
                  ? `${calibration.unidade.city}, ${calibration.unidade.state}`
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Modelo: </strong>
            <span>
              {{
                calibration.equipment
                  ? calibration.equipment.model
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Setor: </strong>
            <span>
              {{
                calibration.equipment && calibration.equipment.department
                  ? calibration.equipment.department.name
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Identificação: </strong>
            <span>
              {{
                calibration.equipment
                  ? calibration.equipment.identification
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Sub-setor: </strong>
            <span>
              {{
                calibration.equipment && calibration.equipment.subDepartment
                  ? calibration.equipment.subDepartment.name
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Cód. Patrimônio: </strong>
            <span>
              {{
                calibration.equipment
                  ? calibration.equipment.propertyCode
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Nº OS: </strong>
            <span>
              {{
                calibration.serviceOrder
                  ? calibration.serviceOrder.number
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Nº Série: </strong>
            <span>
              {{
                calibration.equipment
                  ? calibration.equipment.serialNumber
                  : 'Sem registro'
              }}</span
            >
          </v-col>
        </v-row>
      </section>

      <section>
        <div class="section-title">Informações complementares</div>

        <p class="mt-2 mx-2">
          A incerteza expandida de medição relatada é declarada como a incerteza
          padrão da medição multiplicada pelo fator de abrangência (k), o qual
          para uma distribuição t com determinados graus de liberdade efetivos,
          corresponde a uma probabilidade de abrangência de 95,45%. Os
          resultados deste certificado referem-se exclusivamente ao objeto
          calibrado nas condições especificadas, não sendo extensivo a quaisquer
          equipamentos de mesma natureza. A incerteza padrão de medição foi
          determinada e expressa de acordo com a publicação NIT –DICLA -021
          Expressão da incerteza de Medição. Procedimento: A calibração foi
          realizada pelo método de comparação direta entre o equipamento e um ou
          mais padrões calibrados.
        </p>
      </section>

      <section v-if="calibration.parameters">
        <div class="section-title">Rastreabilidade dos padrões utilizados</div>

        <v-row
          dense
          class="ma-0"
          v-for="parameter in calibration.parameters.filter(
            (obj, index, self) =>
              index === self.findIndex((t) => t.patternId === obj.patternId)
          )"
          :key="parameter.id"
        >
          <v-col cols="6">
            <strong>Padrão: </strong>
            <span>{{
              parameter.patternJson
                ? parameter.patternJson.name
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Órgão calibrador: </strong>
            <span>
              {{
                parameter.patternJson
                  ? parameter.patternJson.calibratingOrgan
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Fabricante: </strong>
            <span>{{
              parameter.patternJson
                ? parameter.patternJson.manufacturer
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Nº certificado: </strong>
            <span>
              {{
                parameter.patternJson
                  ? parameter.patternJson.number
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Modelo: </strong>
            <span>{{
              parameter.patternJson
                ? parameter.patternJson.model
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Validade calibração: </strong>
            <span>
              {{
                parameter.patternJson && parameter.patternJson.expirationDate
                  ? formatDateTime(parameter.patternJson.expirationDate)
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Nº série: </strong>
            <span>
              {{
                parameter.patternJson
                  ? parameter.patternJson.serialNumber
                  : 'Sem registro'
              }}
            </span>
          </v-col>
          <v-col cols="6">
            <strong>Código patrimônio: </strong>
            <span>{{
              parameter.patternJson
                ? parameter.patternJson.propertyCode
                : 'Sem registro'
            }}</span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </section>

      <section>
        <div class="section-title">Condições ambientais</div>

        <v-row class="ma-0" dense>
          <v-col cols="6">
            <strong>Temperatura: </strong>
            <span>{{ calibration.temperature }}</span>
          </v-col>
          <v-col cols="6">
            <strong>Umidade Relativa do Ar: </strong>
            <span>{{ calibration.relativeHumidity }}</span>
          </v-col>
        </v-row>
      </section>

      <section>
        <div class="section-title">Valores medidos durante a calibração</div>

        <v-row
          class="ma-0"
          dense
          v-for="parameter in calibration.parameters"
          :key="parameter.id"
        >
          <v-col cols="12">
            <strong>Parâmetro: </strong>
            <span>{{ parameter.parameterJson.name }}</span>
            <br />
            <strong>Unidade de medida: </strong>
            <span>{{ parameter.metricJson.unit }}</span>
            <br />
            <strong>Resolução: </strong>
            <span>{{ formatNumber(parameter.equipmentResolution) }}</span>
          </v-col>
          <v-col cols="12">
            <table class="my-table">
              <thead>
                <tr>
                  <th class="text-center black--text font-weight-bolder">
                    Ponto
                  </th>
                  <th class="text-center black--text font-weight-bolder">
                    Média
                  </th>
                  <th class="text-center black--text font-weight-bolder">
                    Tendência
                  </th>
                  <th class="text-center black--text font-weight-bolder">
                    Incerteza expandida
                  </th>
                  <th class="text-center black--text font-weight-bolder">K</th>
                  <th class="text-center black--text font-weight-bolder">
                    Tolerância
                  </th>
                  <th class="text-center black--text font-weight-bolder">
                    Resultado
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in parameter.ranges" :key="item.id">
                  <td class="text-center black--text font-weight-medium">
                    {{ item.range }}
                  </td>
                  <td class="text-center black--text font-weight-medium">
                    {{ formatNumber(item.average) }}
                  </td>
                  <td class="text-center black--text font-weight-medium">
                    {{ formatNumber(item.tendency) }}
                  </td>
                  <td class="text-center black--text font-weight-medium">
                    {{ formatNumber(item.expandedUncertainty) }}
                  </td>
                  <td class="text-center black--text font-weight-medium">
                    {{ formatNumber(item.k) }}
                  </td>
                  <td class="text-center black--text font-weight-medium">
                    {{ item.tolerance ?? 0 }}
                  </td>
                  <td
                    class="text-center black--text font-weight-medium"
                    :class="item.result == 1 ? 'disapproved' : 'approved'"
                  >
                    {{ item.result == 1 ? 'Reprovado' : 'Aprovado' }}
                  </td>
                </tr>
              </tbody>
            </table>

            <v-divider class="my-2 mt-8"></v-divider>
          </v-col>
        </v-row>
      </section>

      <section>
        <v-row class="ma-0" dense>
          <v-col cols="6" class="d-flex flex-column align-center">
            <v-img
              v-if="calibration.executingUser"
              :src="calibration.executingSign"
            ></v-img>
            <v-divider class="mb-2" style="width: 280px"></v-divider>
            Assinatura técnico executor
            <p v-if="calibration.executingUser">
              {{ calibration.executingUser.name }}
            </p>
            <p
              v-if="
                calibration &&
                calibration?.executingUser &&
                calibration?.executingUser.professionalRegistration
              "
            >
              {{ $t('Registro Profissional') }}:
              {{
                calibration.executingUser.professionalRegistration ||
                'Não informado'
              }}
            </p>
          </v-col>
          <v-col cols="6" class="d-flex flex-column align-center">
            <v-img
              v-if="calibration.validatorUser"
              :src="calibration.validatorSign"
            ></v-img>
            <v-divider class="mb-2" style="width: 280px"></v-divider>
            Assinatura responsável

            <p v-if="calibration.validatorUser">
              {{ calibration.validatorUser.name }}
            </p>
            <p
              v-if="
                calibration &&
                calibration?.validatorUser &&
                calibration?.validatorUser.professionalRegistration
              "
            >
              {{ $t('Registro Profissional') }}:
              {{
                calibration.validatorUser.professionalRegistration ||
                'Não informado'
              }}
            </p>
          </v-col>
        </v-row>
      </section>

      <div class="text-center text-caption" style="max-width: 400px">
        {{ calibration.footnote }}
      </div>

      <section class="my-8">
        <div class="d-flex align-center justify-center">
          <v-btn
            v-if="!calibration.validatorUserId"
            color="#BBCF20"
            small
            depressed
            :loading="validateLoading"
            @click="validate"
          >
            Validar calibração
          </v-btn>
          <v-btn
            v-else
            color="#B14949"
            small
            depressed
            :loading="validateLoading"
            @click="removeValidation"
          >
            Remover validação
          </v-btn>

          <v-menu offset-y top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" small depressed v-bind="attrs" v-on="on">
                Documentos do certificado
              </v-btn>
            </template>
            <v-list v-if="calibration.parameters">
              <v-list-item
                @click="toCertificateDocuments(parameter.patternJson)"
                v-for="parameter in calibration.parameters.filter(
                  (obj, index, self) =>
                    index ===
                    self.findIndex((t) => t.patternId === obj.patternId)
                )"
                :key="parameter.id"
              >
                <v-list-item-title>
                  Certificados do {{ parameter.patternJson.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn color="#426483" small depressed @click="generatePDF">
            Imprimir certificado
          </v-btn>
        </div>
      </section>
    </v-card>
  </v-container>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  name: 'CertifiedPrint',

  data() {
    return {
      calibration: {},
      institution: {},
      apiService: new ApiService(),
      loading: false,
      validateLoading: false,
    }
  },

  created() {
    if (!this.$route.query.id) this.$toast.error('Calibração não encontrada')

    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.getCalibration()
  },

  methods: {
    generatePDF() {
      this.apiService
        .get(`calibration/v2/certified/pdf/${this.calibration.id}`)
        .then((response) => {
          response = 'data:application/pdf;base64,' + response.content
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', `Certificado`)
          document.body.appendChild(link)
          link.click()
        })
    },

    removeValidation() {
      const model = {
        userId: null,
        certifiedId: this.calibration.id,
      }

      this.validateLoading = true

      this.apiService
        .post('calibration/v2/certified/validate', model)
        .then(() => {
          this.validateLoading = false
          this.getCalibration()
        })
        .catch(() => {
          this.validateLoading = false
        })
    },

    validate() {
      const user = JSON.parse(localStorage.getItem('user'))

      const model = {
        userId: user.id,
        certifiedId: this.calibration.id,
      }

      this.validateLoading = true

      this.apiService
        .post('calibration/v2/certified/validate', model)
        .then(() => {
          this.validateLoading = false
          this.getCalibration()
        })
        .catch(() => {
          this.validateLoading = false
        })
    },

    toCertificateDocuments(pattern) {
      sessionStorage.clear()
      sessionStorage.setItem('calibrationV2Pattern', JSON.stringify(pattern))
      window.open(`/uploadDocument?certified=${pattern.number}`, '_blank')
    },

    formatMonth(date) {
      return date ? moment(date).format('MM/YYYY') : ''
    },

    formatDateTime(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },

    formatNumber(value) {
      return Intl.NumberFormat('pt-BR', {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
      }).format(value)
    },

    getCalibration() {
      this.loading = true
      this.apiService
        .get(`calibration/v2/certified/${this.$route.query.id}`)
        .then((response) => {
          this.calibration = response.content
          console.log(this.calibration)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
* {
  font-family: 'Roboto', sans-serif;
  color: #426483;
  font-size: 16px;
}

.approved {
  background-color: #bacf1c;
}

.disapproved {
  background-color: #b14949;
}

.my-table {
  font-family: 'Roboto', sans-serif;
  display: table;
  page-break-inside: auto;
  table-layout: auto;
  text-align: center;
  border-spacing: 0;
  width: 100%;
  font-size: 12px !important;
}

.my-table td {
  white-space: nowrap;
  border: 1px solid black;
  font-size: 12px !important;
}

.my-table th {
  border: 1px solid black;
  background-color: #bbcf20 !important;
  padding: 5px;
  font-size: 12px !important;
}

.my-table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.my-table thead {
  display: table-header-group;
  white-space: nowrap;
}

section {
  width: 100%;
  margin: 8px 0;
}

.section-title {
  background-color: #3c8ea6;
  color: #fff;
  width: 100%;
  padding: 4px;
  border-radius: 4px;
  text-align: center;
}
</style>
